import { Component, OnInit, ElementRef, ViewChild } from "@angular/core";
import {
  IFilterComponent,
  SearchFilter,
} from "../../../infrastructure/iFilter-component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FilterService } from "../../../services/filter.service";
import { FilterRecordService } from "../../../services/filter-record.service";
import { FilterCompleteService } from "../../../filter-complete/filter-complete";
import { ServiceFilter } from "../../../model/service-filter";
import { PracticeRegionFilter } from "../../../model/practice-region-filter";
import { SpecialityFilter } from "../../../model/speciality-filter";
import { AdmissionService } from "../../../services/admission.service";
import { PatientSearch } from "../../../model/patient/patient-search";
import { AuthService } from "../../../services/auth.service";
import { CenterFilter } from "../../../model/center-filter";
import { PhysicianFilter } from "../../../model/physician-Filter";

@Component({
  selector: "app-admission-filter-component",
  templateUrl: "./admission-filter.component.html",
  styleUrls: ["./admission-filter.component.css"],
})
export class AdmissionFilterComponent implements IFilterComponent, OnInit {
  form: FormGroup;
  @ViewChild("formElement", { static: false }) formElement: ElementRef;
  filterCompleteServices: FilterCompleteService<ServiceFilter>;
  filterCompletePracticesRegion: FilterCompleteService<PracticeRegionFilter>;
  filterCompleteSpecialities: FilterCompleteService<SpecialityFilter>;
  filterCompleteCenters: FilterCompleteService<CenterFilter>;
  filterCompletePhysicians: FilterCompleteService<PhysicianFilter>;

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FilterService,
    private admissionService: AdmissionService,
    private authService: AuthService,
    private filterRecordService: FilterRecordService
  ) {
    this.form = this.formBuilder.group({
      DateFrom: [new Date(), [Validators.required]],
      DateTo: [new Date(), [Validators.required]],
      Protocol: [""],
      Center: [""],
      InSector: [""],
      Service: [""],
      Specialty: [""],
      PracticeRegion: [""],
      Physician: [""],
      Patient: [null],
      OrderByPatient: [false],
      NoViewAdmissionControled: [false],
      ViewPreAdmission: [false],
      ViewCancel: [false],
    });

    this.filterCompletePhysicians = new FilterCompleteService<PhysicianFilter>(
      [],
      this.form.controls.Physician
    );
    this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
      [],
      this.form.controls.Center
    );
    this.filterCompleteSpecialities =
      new FilterCompleteService<SpecialityFilter>(
        [],
        this.form.controls.Specialty
      );
    this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
      [],
      this.form.controls.Service
    );
    this.filterCompletePracticesRegion =
      new FilterCompleteService<PracticeRegionFilter>(
        [],
        this.form.controls.PracticeRegion
      );
  }

  get filteredPhysiciansOptions() {
    return this.filterCompletePhysicians
      ? this.filterCompletePhysicians.filteredOptions
      : [];
  }
  get filteredCentersOptions() {
    return this.filterCompleteCenters
      ? this.filterCompleteCenters.filteredOptions
      : [];
  }
  get filteredSpecialitiesOptions() {
    return this.filterCompleteSpecialities
      ? this.filterCompleteSpecialities.filteredOptions
      : [];
  }
  get filteredServicesOptions() {
    return this.filterCompleteServices
      ? this.filterCompleteServices.filteredOptions
      : [];
  }
  get filteredPracticesRegionOptions() {
    return this.filterCompletePracticesRegion
      ? this.filterCompletePracticesRegion.filteredOptions
      : [];
  }
  get f() {
    return this.form.controls;
  }

  getSearchFilters(): SearchFilter[] {
    const requiredTags: string[] = [];
    requiredTags.push("DateFrom");
    requiredTags.push("DateTo");
    return this.filterRecordService.convertToSearchFilters(
      this.form,
      requiredTags
    );
  }

  async saveFilters() {
    this.filterRecordService.saveFilters("AdmissionFilterComponent", this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters(
      "AdmissionFilterComponent",
      this.form
    );
  }

  async search(): Promise<any> {
    const serviceId = this.form.controls.Service.value
      ? this.form.controls.Service.value.Id
      : null;

    let sectorId: number = null;
    if (this.form.controls.InSector.value) {
      sectorId = this.authService.getSectorId();
    }


    const noViewAdmissionControled = this.form.controls.NoViewAdmissionControled
      .value
      ? this.form.controls.NoViewAdmissionControled.value
      : false;

    let admissionControled = null;

    if (noViewAdmissionControled) {
      admissionControled = false;
    }

    return await this.admissionService.getAdmissionSearchItemsAdmited(
      <Date>this.form.controls.DateFrom.value,
      <Date>this.form.controls.DateTo.value,
      this.form.controls.Protocol.value,
      this.authService.getCompanyIds(),
      serviceId,
      this.form.controls.OrderByPatient.value
        ? this.form.controls.OrderByPatient.value
        : false,
      this.form.controls.ViewPreAdmission.value
        ? this.form.controls.ViewPreAdmission.value
        : false,
      false,
      this.form.controls.ViewCancel.value
        ? this.form.controls.ViewCancel.value
        : false,
      this.form.controls.Patient.value
        ? this.form.controls.Patient.value.Id
        : null,
      this.form.controls.PracticeRegion.value
        ? this.form.controls.PracticeRegion.value.Id
        : null,
      this.form.controls.Specialty.value
        ? this.form.controls.Specialty.value.Id
        : null,
      this.form.controls.Center.value
        ? this.form.controls.Center.value.Id
        : null,
      sectorId,
      this.form.controls.Physician.value
        ? this.form.controls.Physician.value.Id
        : null,
      admissionControled
    );
  }

  ngOnInit() {
    this.filterService.getServicesFilter().then((services) => {
      this.filterCompleteServices = new FilterCompleteService<ServiceFilter>(
        services,
        this.form.controls.Service
      );
    });

    this.filterService.getPracticesRegionFilter().then((practicesRegion) => {
      this.filterCompletePracticesRegion =
        new FilterCompleteService<PracticeRegionFilter>(
          practicesRegion,
          this.form.controls.PracticeRegion
        );
    });

    this.filterService.getSpecialtiesFilter().then((specialities) => {
      this.filterCompleteSpecialities =
        new FilterCompleteService<SpecialityFilter>(
          specialities,
          this.form.controls.Specialty
        );
    });

    this.filterService.getPhysiciansFilter().then((physicians) => {
      this.filterCompletePhysicians =
        new FilterCompleteService<PhysicianFilter>(
          physicians,
          this.form.controls.Physician
        );
    });

    this.filterService.getCentersFilter().then((centers) => {
      this.filterCompleteCenters = new FilterCompleteService<CenterFilter>(
        centers,
        this.form.controls.Center
      );
    });
  }
}
